// extracted by mini-css-extract-plugin
module.exports = {"root":"ActiveOptionChip_root__4rr7I","cancel":"ActiveOptionChip_cancel__2sYTX","iconCancel":"ActiveOptionChip_iconCancel__3KB8w"};